import type enTranslation from '@common/i18n/translations/en.json'

export const getButtonText = (
  translate: (key: keyof typeof enTranslation) => string,
  application: IApplication,
  version?: string,
): string => {
  if(version && application.isInstalled) {
    if(version === application?.installed?.id) {
      return translate('Update app')
    } else {
      return translate('Upgrade & apply')
    }
  }
  if(application.hasUpdate) { return translate('Upgrade & apply') }
  if(application.isInstalled && !application.isActive) { return translate('Restart') }
  return application.isInstalled ? translate('Update app') : translate('Add app')
}

export const getDisabledStatus = (application: IApplication, settings: IApplicationSettingKeyed[], permissions: IPermissionKeyed[], isDirty: boolean, version?: string): boolean => {
  if(application.hasUpdate) { return false }
  if(application.isInstalled && !application.isActive) { return false }
  if(version && application?.installed?.id !== version) { return false }
  if(application.isInstalled && !isDirty) { return true }
  return !(settings.length || permissions.length) && application.isInstalled
}
